/* eslint-disable no-mixed-spaces-and-tabs */
import Loader from '@/components/ui/Loader/Loader';
import nf, { nfRp } from '@/constants/nf';
import { ExpandMore } from '@mui/icons-material';
import dayjs from 'dayjs';
import { Accordion, AccordionDetails, AccordionSummary, Pagination } from '@mui/material';
import { useSelector } from 'react-redux';
import { format } from 'date-fns';

export default function NewTopUps({ isFetching, isFetched, topUpList, topUpCount, page, handleChangePagination }) {
	const accountType = useSelector((state) => state.auth.accountType);
	const isParent = accountType === 'parent';
	const money = (n) => (isParent ? nfRp(n) : nf(n));

	if (isParent) {
		return (
			<div className='relative flex flex-col min-h-24'>
				{isFetching && <Loader />}
				{isFetched && topUpList?.length > 0 &&
					topUpList.map((t) => {
						const date = dayjs(new Date(t.date)).format('dddd, D MMMM YYYY');
						return (
							<details key={t.date} className='topup-history-day'>
								<summary>
									<span>{date}</span>
									<ExpandMore fontSize='small' style={{ color: 'var(--jt-muted)' }} />
								</summary>
								<div className='topup-history-body'>
									{t.topUps.map((to) => (
										<div key={to.id} className='topup-history-line'>
											<div>
												<strong>{String(to.status || '').toUpperCase()}</strong>
												<div className='meta'>
													{to.requested_at ? format(new Date(to.requested_at), 'HH:mm') : ''}
													{to.payment_type_name ? ` · ${to.payment_type_name}` : ''}
													{` · #${to.id}`}
												</div>
												{to.note && <div className='meta'>Reason: {to.note}</div>}
											</div>
											<strong>{money(Math.abs(+to.amount))}</strong>
										</div>
									))}
								</div>
							</details>
						);
					})}
				{isFetched && (!topUpList || topUpList.length === 0) && (
					<p className='orders-empty'>No top up found</p>
				)}
				{isFetched && topUpCount > 1 && (
					<Pagination className='mt-4 ml-auto' count={topUpCount} page={page} onChange={handleChangePagination} />
				)}
			</div>
		);
	}

	return (
		<div className='relative flex flex-col min-h-24'>
			{isFetching && <Loader />}
			{isFetched && topUpList?.length > 0 && (
				<div className='flex flex-col gap-4 mt-4'>
					{topUpList.map((t) => {
						const tItems = t.topUps.map((to) => {
							return (
								<div key={to.id}>
									<table className='w-full table-fixed'>
										<tbody>
											<tr>
												<td className='break-words pr-2 align-top w-[15%]'>
													({to.id}) {to.requested_at ? format(new Date(to.requested_at), 'HH:mm') : ''}
												</td>
												<td className='break-words pr-2 text-center align-top w-[35%]'>{to.status.toUpperCase()}</td>
												<td className='break-words pr-2 text-center align-top w-[23%]'>{to.payment_type_name}</td>
												<td className='break-words text-right align-top w-[27%]'>{nf(Math.abs(+to.amount))}</td>
											</tr>
										</tbody>
									</table>
									{to.note && <span className='w-full pl-2 text-sm italic'>Reason: {to.note}</span>}
								</div>
							);
						});
						const date = dayjs(new Date(t.date)).format('dddd, DD MMMM YYYY');
						return (
							<Accordion key={t.date}>
								<AccordionSummary expandIcon={<ExpandMore />} aria-controls='panel1-content' id='panel1-header'>
									<span className='font-bold'>{date}</span>
								</AccordionSummary>
								<AccordionDetails>
									<div className='flex flex-col gap-2'>
										<div className='flex flex-col gap-1'>{tItems}</div>
									</div>
								</AccordionDetails>
							</Accordion>
						);
					})}
				</div>
			)}
			{isFetched && ((typeof topUpList === 'object' && Object.keys(topUpList).length === 0) || topUpList?.length === 0) && (
				<span className='w-full text-center'>No top up found</span>
			)}
			{isFetched && <Pagination className='mt-4 ml-auto' count={topUpCount} page={page} onChange={handleChangePagination} />}
		</div>
	);
}
